module.exports = __webpack_public_path__ + "img/Isle of Man.21eb8c10.svg";